module.exports = __webpack_public_path__ + "img/mobile-elbow-20_70x62.6d742db6.png";